module.exports = __webpack_public_path__ + "ef987bcee54d888950ee8f380df7711c.svg";